import { Instance } from 'mobx-state-tree'
import { AggregatedPlayerStatsModelBase } from './AggregatedPlayerStatsModel.base'

/* The TypeScript type of an instance of AggregatedPlayerStatsModel */
export interface AggregatedPlayerStatsModelType extends Instance<typeof AggregatedPlayerStatsModel.Type> {}

/* A graphql query fragment builders for AggregatedPlayerStatsModel */
export {
  selectFromAggregatedPlayerStats,
  aggregatedPlayerStatsModelPrimitives,
  AggregatedPlayerStatsModelSelector
} from './AggregatedPlayerStatsModel.base'

/**
 * AggregatedPlayerStatsModel
 */
export const AggregatedPlayerStatsModel = AggregatedPlayerStatsModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
